// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "97b73048aa77effa59666790d8d89ab3c63c97db/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};